// --------------------------------------------------------------
// Created On: 2021-09-30
// Author: Zachary Thomas
//
// Last Modified: 2026-02-19
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Warning from "src/components/Warning/Warning";

// Information about the account that is about to be created.
export default function AccountInfo(props: Props): Component {
  return (
    <div>
      {props.accountType === "NEW_COMPANY" && (
        <Warning
          message={
            "You are creating a brand-new company account. " +
            "This account will be completely separate from any existing company accounts. " +
            "If you’re trying to access assets, logs, or user info from an existing account, " +
            "request an invite from the account owner instead of creating a new one."
          }
        />
      )}

      {props.accountType === "EXISTING_COMPANY" && (
        <Warning
          message={
            "The company name you have entered already exists. " +
            "If you want to join an existing company, you will need an invite from an administrator of that company."
          }
        />
      )}
    </div>
  );
}

interface Props {
  accountType: "NEW_ACCOUNT" | "NEW_COMPANY" | "EXISTING_COMPANY";
}
